import { Component, ElementRef } from '@angular/core';
import { BaseView } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';

@Component({
  selector: 'init-view',
  templateUrl: './init.view.html',
})
// Vue d'initialisation pour chargement du contexte
export class InitView extends BaseView {

}